"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// import { EventWeek } from './components/EventWeek';
var FlexEventWeeks = /*#__PURE__*/function (_React$PureComponent) {
  function FlexEventWeeks(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, FlexEventWeeks);
    _this = _callSuper(this, FlexEventWeeks, [props]);
    _this.state = {};
    return _this;
  }
  (0, _inherits2["default"])(FlexEventWeeks, _React$PureComponent);
  return (0, _createClass2["default"])(FlexEventWeeks, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // If a destination is passed as a prop then we set it in the state and use that
      // Else if a destination id is set then fetch it from YL api
      // Otherwise use custom weeks set in acf

      // UPDATE
      // This is only using customWeeks now, it is a temp solution for now, but later on we
      // can extent WeklyTabs to take in  custom weeks + standard weeks when we have time
    }
  }, {
    key: "render",
    value: function render() {
      // const { title, customWeeks } = this.props;
      // commenting out whole thing because wanna delete Alice-carousel package
      return null;
      // return (
      //   <div className="wrap" id="event-weeks">
      //     <div className="wrap">
      //       <React.Fragment>
      //         {title ? (
      //           <h2 className="tac">{title}</h2>
      //         ) : (
      //           <h2 className="tac">{customWeeks.length > 1 ? 'Event weeks' : 'Event week'}</h2>
      //         )}
      //         <div>
      //           <AliceCarousel
      //             infinite={false}
      //             responsive={{
      //               0: {
      //                 items: 1
      //               },
      //               1024: {
      //                 items: 3
      //               }
      //             }}
      //           >
      //             {customWeeks.map((week, i) => (
      //               <EventWeek
      //                 weekNumber={week.week_number}
      //                 eventMusic={week.event_music}
      //                 eventMusicLink={week.event_music_link}
      //                 beginDate={week.begin_date}
      //                 endDate={week.end_date}
      //                 price={week.price}
      //                 link={week.link}
      //                 soldOut={false}
      //                 key={week.begin_date}
      //                 isLast={i === customWeeks.length - 1}
      //               />
      //             ))}
      //           </AliceCarousel>
      //         </div>
      //       </React.Fragment>
      //     </div>
      //   </div>
      // );
    }
  }]);
}(_react["default"].PureComponent);
FlexEventWeeks.propTypes = {
  destinationId: _propTypes["default"].string,
  destination: _propTypes["default"].object,
  title: _propTypes["default"].string,
  customWeeks: _propTypes["default"].array
};
var _default = exports["default"] = FlexEventWeeks;